var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u5716\\u5C64_1",
    "data-name": "\\u5716\\u5C64 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 25 24.87",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "0610_\u5F8C\u53F0") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.07,15.61a.62.62,0,0,0-.62.62v5.53a1.87,1.87,0,0,1-1.87,1.87H3.11a1.87,1.87,0,0,1-1.86-1.87V5.54A1.86,1.86,0,0,1,3.11,3.67H8.64a.63.63,0,0,0,0-1.25H3.11A3.12,3.12,0,0,0,0,5.54V21.76a3.11,3.11,0,0,0,3.11,3.11H20.58a3.12,3.12,0,0,0,3.12-3.11V16.23A.63.63,0,0,0,23.07,15.61Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.45.82a2.81,2.81,0,0,0-4,0L8.38,11.93a.57.57,0,0,0-.16.27L6.76,17.48a.62.62,0,0,0,.76.76l5.28-1.46a.57.57,0,0,0,.27-.16L24.18,5.51a2.81,2.81,0,0,0,0-4ZM9.74,12.33l9.09-9.09,2.93,2.93-9.09,9.1Zm-.59,1.18,2.34,2.34-3.24.9ZM23.3,4.63l-.66.66L19.71,2.36l.66-.66a1.55,1.55,0,0,1,2.2,0l.73.73A1.55,1.55,0,0,1,23.3,4.63Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.b5679e302661d6d35a5c9a8f5f1a7b35.svg";
export { ForwardRef as ReactComponent };